import { create } from 'zustand';

/**
 * Tracks which news articles the member has opened, persisted to localStorage so
 * the News home widget can show an unread indicator across sessions. Mirrors the
 * load/save pattern of {@link useHomeLayoutStore}.
 */
const STORAGE_KEY = 'paas_news_read';

function load(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) return parsed.filter((v): v is string => typeof v === 'string');
    }
  } catch {
    /* ignore corrupt storage */
  }
  return [];
}

function save(ids: string[]): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  } catch (error) {
    console.warn('[news-read] persist failed:', error);
  }
}

interface NewsReadState {
  readIds: string[];
  isRead: (articleId: string) => boolean;
  markRead: (articleId: string) => void;
}

export const useNewsReadStore = create<NewsReadState>((set, get) => ({
  readIds: load(),
  isRead(articleId) {
    return get().readIds.includes(articleId);
  },
  markRead(articleId) {
    if (!articleId || get().readIds.includes(articleId)) return;
    const next = [...get().readIds, articleId];
    set({ readIds: next });
    save(next);
  },
}));
